export const opportunityActionTypes = {
    SET_PROJECT_TYPE: "SET_PROJECT_TYPE",
  };
  
  export const setProjectType = (projectType) => ({
    type: opportunityActionTypes.SET_PROJECT_TYPE,
    payload: projectType,
  });